<template>
    <div class="mainBody">
        <!-- <div class="searchBox">
            <div class="searchGroup">
                <label>名称：</label>
                <el-input v-model="search_Obj.f_xxxname" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
        </div> -->
        <div class="dataBox">
            <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                <el-table-column prop="id" label="广告类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.id == 1">营地详情广告</span>
                        <span v-if="scope.row.id == 2">交付中心首页广告</span>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_name1" label="商品一" sortable="custom"></el-table-column>
                <el-table-column prop="goods_name2" label="商品二" sortable="custom"></el-table-column>
                <el-table-column prop="show_state" label="是否显示" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ transEnu(scope.row.show_state, "show_state") }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :total="total" @current-change="pageChange"></el-pagination>
        </div>
        <Edit
            width="600px"
            :id="model_id"
            :title="edit_title"
            :isshow="editshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </Edit>
        <Info
            width="600px"
            :id="model_id"
            title="查看营地广告"
            :isshow="infoshow"
            @on-close="closeInfoDialog">
        </Info>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'momentAdList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns},
    data() {
        return {
            m_name: '营地广告',
            menu_id: 8400,
            list_url: "/api/admin/momentad/list",
            search_Obj: {
                f_xxxname: '',
            },
            del_Obj:{
                url:'/api/admin/momentad/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['show_state'],
        };
    },
    methods: {}
};
</script>